export default "__VITE_ASSET__Db1j_2FN__"